import useValidator from 'Shared/hooks/useValidator'

const TextField = ({label, id, error, className, ...props}) => {
  const [inputProps, validatorError] = useValidator(props)
  const errorMessage = error || validatorError

  return (
    <div className={`field ${className || ''}`}>
      {label && <label htmlFor={id}>{label}</label>}
      <input {...inputProps} type="text" id={id} />
      {errorMessage && <span className="error">{errorMessage}</span>}
    </div>
  )
}

export default TextField
